<agpr-dialog-container
    [id]="id + '.container'"
    [heading]="heading"
    (close)="cancel()"
>
    <div
        [agprLoading]="loading"
        class="agpr-textInputDialog-content"
        [ngClass]="{
            'agpr-textInputDialog-content-social': style === componentStyle.social
        }"
        [style.width]="width + 'px'"
    >
        <p *ngIf="message" class="agpr-textInputDialog-message">
            {{ message | localize }}
        </p>
        <agpr-text-input
            *ngIf="!useTextarea"
            [id]="id+'.textInput'"
            [initialFocus]="true"
            [maxLength]="maxLength"
            [placeholder]="placeholder"
            [(ngModel)]="value"
            (ngModelChange)="clearErrors()"
            [style]="style"
            [label]="description"
            [required]="true"
            [type]="type"
            [ariaInvalid]="errors.length > 0"
            [ariaDescribedBy]="id +'_textInputDialog_errorMessages'"
        ></agpr-text-input>
        <agpr-textarea-input
            *ngIf="useTextarea"
            [id]="id+'.textareaInput'"
            [initialFocus]="true"
            [maxLength]="maxLength"
            [placeholder]="placeholder"
            [bottomMargin]="false"
            [(ngModel)]="value"
            (ngModelChange)="clearErrors()"
            [style]="style"
            [label]="description"
            [required]="true"
            [ariaDescribedBy]="id +'_textInputDialog_errorMessages'"
        ></agpr-textarea-input>
        <ul  [id]="id +'_textInputDialog_errorMessages'">
            <li  *ngFor="let error of errors">
                <agpr-form-message>
                    {{ error | localize }}
                </agpr-form-message>
            </li>
        </ul>
    </div>
    <ng-template #footerLeft>
        <agpr-button
            id="textInput.cancelButton"
            (click)="cancel()"
            [label]="cancelLabel"
            [disabled]="loading"
            [style]="buttonStyle.secondary"
        ></agpr-button>
    </ng-template>
    <ng-template #footerRight>
        <span
            id="textInput_okButton_disabledTooltip"
            class="u-srOnly"
            *ngIf="!value || !isValid || loading"
        >
            {{ disabledButtonTooltip | localize}}
        </span>
        <agpr-button
            id="textInput.okButton"
            (click)="ok()"
            [label]="okLabel"
            [ariaLabel]="okLabel"
            [disabled]="!value || !isValid || loading"
            [style]="buttonStyle.primary"
            [tooltip]="(!value || !isValid || loading) ? disabledButtonTooltip : ''"
            [ariaDescribedBy]="'textInput_okButton_disabledTooltip'"
        ></agpr-button>
    </ng-template>
</agpr-dialog-container>
